import React from 'react';
import { ButtonAction, sanitize } from '@honeycomb-npm/honeycomb-react';
import { content } from '../../../utils/contentUtils';
import { isNetbankCustomer } from '../../../utils/customerTypeUtils';
import constants from '../../../constants';
import './Banner.scss';

const Banner = () => {
  const isNetBankUser = isNetbankCustomer;
  const { netBankCustomers: netBankContent, allCustomers: allCustomerContent, callToAction: callToActionContent } = content;
  const bannerContent = isNetBankUser ? netBankContent : allCustomerContent;
  const { AnalyticsConstants } = constants;
  const { unsubscribeLoginNetbank } = AnalyticsConstants;
  return (
    <div className="row mx-0 px-0">
      <div className="col-12 px-0">
        <div className="hero-banner col-lg-9 col-md-12 mt-8 mb-6 pl-2 pl-sm-4 pl-md-6 pr-4">
          <h1>{bannerContent.customersTitle}</h1>
          <div dangerouslySetInnerHTML={sanitize(bannerContent.customerDescription)} />
        </div>
        {isNetBankUser && (
          <div className="col-lg-9 col-md-12 my-4 pl-3 pl-sm-6 pl-md-8">
            <ButtonAction
              id={unsubscribeLoginNetbank}
              href={callToActionContent.netbankBtn.link.url}
              target={callToActionContent.netbankBtn.link.target}
            >
              {callToActionContent.netbankBtn.displayText}
            </ButtonAction>
          </div>
        )}
      </div>
    </div>
  );
};

export default Banner;
